import React, { useState } from "react"
import { Modal, Button } from "react-bootstrap"

import RunDetailsDiv from "../../resources/RunDetailsDiv"

export default function StopRunModal({
  intl,
  show,
  onHide,
  submitForm,
  selectedRun,
  warning,
  linkRunName = true,
}) {
  const [isLoading, setIsLoading] = useState(false)
  return (
    <Modal
      size={"xl"}
      dialogClassName={"common-modal"}
      show={show}
      onHide={onHide}
      style={{ overflowX: "scroll", overflowY: "scroll" }}
      backdrop={"static"}
    >
      <Modal.Header closeButton>
        <Modal.Title className={"text-center"}>
          {intl.formatMessage({ id: "areyousuremodal.header", defaultMessage: "Everything Look Okay?" })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {warning && (
          <p style={{ marginTop: "10px", marginBottom: "20px" }} className={"error-message"}>
            {intl.formatMessage({
              id: "general.server.error",
              defaultMessage: "Error! Could not process request",
            })}
            :{warning.toString()}
          </p>
        )}
        <div>
          <h4 className={"text-center"}>
            {intl.formatMessage({ id: "fermmanagement.stop.run", defaultMessage: "Stop Run" })}?
          </h4>
          <div style={{ marginTop: "25px" }}>
            <RunDetailsDiv
              selectedRun={selectedRun}
              showLog={false}
              viewMetadata={false}
              viewExperiments={false}
              linkRunName={linkRunName}
              intl={intl}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={"outline-primary"}
          disabled={isLoading}
          onClick={onHide}
          style={{ marginRight: "auto" }}
        >
          {intl.formatMessage({ id: "general.cancelButton", defaultMessage: "Cancel" })}
        </Button>
        <Button
          variant={"primary"}
          style={{ marginLeft: "auto" }}
          disabled={isLoading}
          onClick={(e) => {
            setIsLoading(true)
            submitForm(e, selectedRun, () => setIsLoading(false))
          }}
        >
          {isLoading ? (
            <>
              <div className="spinner-border spinner-border-sm text-primary text-center" role="status" />
              &nbsp;
              {intl.formatMessage({ id: "general.loading", defaultMessage: "Loading" })}...
            </>
          ) : (
            <span>{intl.formatMessage({ id: "general.submitButton", defaultMessage: "Submit" })}</span>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
